import React from "react";
import "./css/sections.css";
import seaVideo from "../assets/videos/st6.mp4";
import seaVideo2 from "../assets/videos/Seatech.mp4";
import { useState } from "react";
import Popup from "../components/Popup";

function Home() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <div id="home" className="homeContainer">
      <div className="overlay"></div>
      <video
        className="homeVideo"
        autoPlay
        muted
        loop
        id="myVideo"
        src={seaVideo}
        alt="woodworking"
      />

      <div className="heroContent">
        <h1 className="heroTitle">
          We Are Here For You, <span className="highlight">SEATECH</span>
        </h1>
        <p className="heroDescription">
          Seatech Infra Pvt Ltd delivers sewer line cleaning and maintenance
          services , specializing in efficient manhole management. We also offer
          flexible vehicle rental solutions.
        </p>
        {/* <button className="readMoreBtn" onClick={openPopup}>
          Read More
        </button> */}
      </div>
      {/* <Popup
        isOpen={isPopupOpen}
        onClose={closePopup}
        title="SEATECH INFRA PVT. LTD."
        videoSrc={seaVideo2}
        description="At Seatech Infra Pvt. Ltd., we specialize in sewer line cleaning and drainage maintenance. With years of experience and a skilled team, we take pride in delivering reliable and efficient solutions for our clients. Whether it's a routine check or an emergency blockage, we use advanced tools and proven methods to get the job done right. Our goal is to ensure clean, safe, and smoothly running drainage systems, while providing excellent service and lasting results our clients can count on."
      /> */}
    </div>
  );
}

export default Home;
